/** The side menu's grid track in `Layout`; every page gets the screen minus this. */
export const LAYOUT_SIDEBAR_WIDTH_PX = 40;
